module.exports = "/_next/static/images/chrome-badge-e5618c63c47fed4c54bf9bd47e3de41c.png";